<template>
    <div class="batch-publish-comp">
        <div class="left table-list">
            <div class="mask"></div>
            <div v-if="housesCid.length" class="selected-tips">
                <div class="wording">
                    已選取 {{housesCid.length}} 個房源
                </div>
            </div>
            <div v-if="this.filterTag.length" class="filter-tips">
                <span class="result">
                    {{filterByWord.length}} 個結果
                </span>
                <span class="item" v-for="(item, index) in this.filterTag" :key="index">
                    {{item}}
                </span>
            </div>
            <div class="table-list-title">
                <span class="checkbox">
                    <checkbox v-model="checkboxStatus.checkboxAll"  :isPropChecked="checkboxStatus.checkboxAll"></checkbox>
                </span>
                <span class="address">地址</span>
                <span class="house-name">房源名稱</span>
                <span class="rent">租金</span>
                <span class="status">房源狀態</span>
            </div>
            <div class="table-list-body">
                <div v-if="isLoading" class="filter-empty">
                    <table-loading />
                </div>
                <div v-else-if="filterByWord.length == 0 && batchPublishList.length != 0" class="filter-empty">
                    <span>0 個搜尋結果</span>
                    <!-- <button class="default-button" @click="setFilterDefault">清除篩選</button> -->
                </div>
                <div v-else-if="batchPublishList.length == 0" class="is-empty">無可上架房源</div>
                <ul  v-else>
                    <li v-for="(list,index) in filterByWord" :key="index">
                        <span class="checkbox" @click="clearSuccessFlag">
                            <checkbox :val="list.houseId" v-model="housesCid" :isPropChecked="checkboxStatus.checkboxAll || checkboxStatus.forceUpdate"></checkbox>
                        </span>
                        <span class="address to-dot">{{list.address}}</span>
                        <span class="house-name to-dot">
                            {{list.houseName.length >= 6?compressWord(list.houseName, 6):list.houseName}}
                            <div v-if="list.houseName.length >= 6" class="full-word">
                                <span>
                                    {{list.houseName}}
                                </span>
                            </div>
                        </span>
                        <span class="rent">{{toCurrency(list.rentMonthly)}}</span>
                        <span class="status">
                            <span class="gray" v-if="list.houseStatus == 'REVEAL'">未租</span>
                            <span class="blue" v-if="list.houseStatus == 'RENTED'">已租</span>
                        </span>
                        <!-- <span v-if="successFlag[index]">
                            <img src="@/assets/img/icon/success_done.svg" alt="">
                        </span> -->
                    </li>
                </ul>
            </div>
        </div>
        <div class="right">
            <batch-publish-filter></batch-publish-filter>
        </div>
    </div>
</template>
<script>
import Checkbox from '@/components/bussiness/widges/input/checkbox.vue';
import batchPublishFilter from '@/components/bussiness/mgtCategory/houseMgt/batchPublish/batchPublishFilter.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            checkboxStatus: {
                checkboxAll: false,
                forceUpdate: null
            },
            housesCid: [],
            successFlag: [],
            isLoading: true
        }
    },
    created () {
        this.$store.dispatch('getBizBatchPublishList')
        .then(()=>{
            this.isLoading = false
        })
    },
    watch: {
        // batchPublishList: {
        //     handler: function (val) {
        //         console.log(val)
        //         for (let i = 0; i < val.length; i++) {
        //             this.checkboxStatus.checkboxList[i] = false
        //         }
        //     },
        //     immediate: true
        // } ,
        checkboxStatus: {
            handler: function (val) {
                console.log(val)
                setTimeout(()=>{
                    this.$store.dispatch('setBizBatchPublishCheckboxStatus', val)
                },500)
            },
            deep: true
        },
        housesCid: {
            handler: function (val) {
                this.$store.dispatch('setBizBatchPublishSeletedHouse', val)
                if(val.length === 0){
                    this.checkboxStatus.checkboxAll = false
                }else if(this.filterByWord.length === val.length){
                    this.checkboxStatus.checkboxAll = true
                }
            },
            deep: true
        },
        filterQueryUpdate: function () {
            this.clearCheckbox()
        },
        'checkboxStatus.checkboxAll': function (val) {
            this.clearSuccessFlag()
            let list = this.filterByWord
            if(val){
                for (let i = 0; i < list.length; i++) {
                    const element = list[i];
                    if(!this.housesCid.includes(element.houseId)){
                        this.housesCid.push(element.houseId)
                    }
                }
            }else{
                this.housesCid = []
            }
        },
        successList: function (val) {     
            this.clearCheckbox()
            for (let i = 0; i < this.filterByWord.length; i++) {
                const element = this.filterByWord[i];
                if(val.includes(this.filterByWord[i].houseId)){
                    this.successFlag[i] = true
                }
            }
        }
    },
    methods: {
        clearCheckbox: function () {
            this.checkboxStatus.forceUpdate = false
            this.housesCid = []
            setTimeout(()=>{
                this.checkboxStatus.forceUpdate = null
            }, 500)
        },
        clearSuccessFlag: function () {
            this.successFlag = []
        }
    },
    computed: {
        filterByCounty: function () {
            return this.batchPublishList.filter((item) => {
                if(this.filterQuery.county){
                    if(item.city === this.filterQuery.county){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByDistrict: function () {
            return this.filterByCounty.filter((item) => {
                if( this.filterQuery.district){
                    if(item.district === this.filterQuery.district){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByHouseStatus: function () {
            return this.filterByDistrict.filter((item) => {
                if( this.filterQuery.houseStatus ){
                    if( this.filterQuery.houseStatus == item.houseStatus ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByHouseType: function () {
            return this.filterByHouseStatus.filter((item) => {
                if( this.filterQuery.houseType ){
                    if( this.filterQuery.houseType == item.houseType ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByBuildingType: function () {
            return this.filterByHouseType.filter((item) => {
                if( this.filterQuery.buildingType ){
                    if( this.filterQuery.buildingType == item.buildingType ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByGroup: function () {
            return this.filterByBuildingType.filter((item) => {
                if(this.filterQuery.group){
                    if(item.groupName == this.filterQuery.group ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterBySales: function () {
            return this.filterByGroup.filter((item) => {
                if(this.filterQuery.member){
                    if(item.salesName == this.filterQuery.member ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByLandlord: function () {
            return this.filterBySales.filter((item) => {
                if(this.filterQuery.landlord){
                    if(item.landlordName == this.filterQuery.landlord){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByWord: function () {
            return this.filterByLandlord.filter((item) => {
                this.filterQueryUpdate
                if( this.filterQuery.word ){
                    if( item.address.includes(this.filterQuery.word) ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterTag: function () {
            let filterTag = []
            let index = 0
            for( var item in this.filterQuery ){
                let filterValue = this.filterQuery[item]
                if(filterValue && item != 'countyId'){
                    filterValue = this.transFilterTagContent(item, filterValue)
                    filterTag[index] = this.transFilterTagTitle(item)+'：'+filterValue
                    index++
                }
            }
            return filterTag
            
        },
        ...mapGetters({
            batchPublishList: 'GET_BIZ_BATCH_PUBLISH_LIST',
            filterQuery: 'GET_BIZ_BATCH_PUBLISH_FILTER_QUERY',
            filterQueryUpdate: 'GET_BIZ_BATCH_PUBLISH_FILTER_QUERY_UPDATE',
            successList: 'GET_BIZ_BATCH_PUBLISH_SUCCESS_LIST'
            // housesCid: 'GET_BIZ_BATCH_PUBLISH_SELECTED_HOUSE_CID',
            // policyCid: 'GET_BIZ_BATCH_PUBLISH_SELECTED_PUBLISH_CID'
        })
    },
    components: {
        Checkbox,
        batchPublishFilter,
        tableLoading
    }
}
</script>
<style lang="scss">
    .batch-publish-comp{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        .table-list{
            width: 850px;
            .table-list-title{
                padding: 16px;
            }
            .table-list-body ul li{
                padding: 16px;
            }
            .checkbox{
                width: 20px;
                margin-right: 16px;
            }
            .address{
                width: 262px;
                margin-right: 105px;
            }
            .house-name{
                width: 100px;
                margin-right: 75px;
            }
            .rent{
                width: 51px;
                margin-right: 105px;
            }
            .status{
                width: 76px;
                margin-right: 29px;
                >span{
                    width: 100%;
                    height: 38px;
                    border-radius: 4px;
                    font-weight: 500;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .gray{
                    background-color: #f3f3f3;
                    color: #676362;
                }
                .blue{
                    background-color: rgba(79, 181, 192, 0.08);
                    color: #71aae5;
                }
            }
            .to-dot{
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
            }
        }
    }
    .page-setting.fixed .batch-publish-comp .table-list .table-list-title {
        position: relative;
        top: unset;
        z-index: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseMgt/batchPublish/batchPublishComp.vue